export default __webpack_public_path__ + "static/media/discount.581d68e4.png";